import React, { useEffect } from "react";
import axios from "axios";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TheHouse, TheMark, TheCurator, ThePromise } from "@/components/Story";
import { TheCraft } from "@/components/Forte";
import { TheFeed } from "@/components/Feed";
import { Footer } from "@/components/Footer";

let viewTracked = false;

export default function HomePage() {
  useEffect(() => {
    if (viewTracked) return;
    viewTracked = true;
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/track/view`, { path: "/" }).catch(() => {});
  }, []);

  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <TheHouse />
      <TheMark />
      <TheCurator />
      <TheCraft />
      {/* BoxBuilder temporarily hidden — owner will re-enable when the hamper menu is ready */}
      <ThePromise />
      <TheFeed />
      <Footer />
    </main>
  );
}
